import { FormCategory } from "@simplyk/common";

import {
  DonationFormFrontendPageOutput,
  DonationFormWithUserOrOrgAccessOutput,
  TicketingFrontendPageOutput,
  TicketingOutput,
} from "@/common/types/trpc";

type AnyTicketingOutput = TicketingOutput | TicketingFrontendPageOutput;
type AnyDonationFormOutput = DonationFormWithUserOrOrgAccessOutput | DonationFormFrontendPageOutput;
type AnyFormOutput = AnyTicketingOutput | AnyDonationFormOutput;

export const isTicketing = <Form extends AnyFormOutput>(form: Form): form is Extract<Form, AnyTicketingOutput> => {
  return "ticketingFields" in form && Boolean(form.ticketingFields);
};

export const isDonationForm = <Form extends AnyFormOutput>(
  form: Form
): form is Extract<Form, AnyDonationFormOutput> => {
  return "donationFormFields" in form && Boolean(form.donationFormFields);
};

export const isFormCategory = (category: unknown): category is FormCategory => {
  return typeof category === "string" && Object.values(FormCategory).includes(category as FormCategory);
};
